
<cloud-history-table-spinner *ngIf="!isInitialLoadDone"/>

<mat-card appearance="outlined" class="mat-elevation-z8" *ngIf="isInitialLoadDone">
    <div class="container">
        <div class="row">
            <mat-tab-group class="col" (selectedTabChange)="onTabChange($event)">
                <!-- Parcel signing -->
                <mat-tab>
                    <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                        <cqes-icon [icon]="icons.developer_board" class="icon-margin-right"></cqes-icon>
                        {{'businessTexts.tabNameParcelSigning' | translate}}
                    </ng-template>
                    <mat-card>
                        <cloud-parcel-signing></cloud-parcel-signing>
                    </mat-card>
                </mat-tab>

                <!-- Registered mail signing -->
                <mat-tab [disabled]="!canAccessRegisteredMail">
                    <ng-template mat-tab-label>
                         <cqes-icon [icon]="icons.mail_outline" class="icon-margin-right"></cqes-icon>
                        {{'businessTexts.tabNameRegisteredMailSigning' | translate}}
                    </ng-template>
                    <mat-card *ngIf="hasSecondTabBeenSelected">
                        <cloud-registered-mail-signing></cloud-registered-mail-signing>
                    </mat-card>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</mat-card>
